import React, { useEffect } from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import image from "../assests/services_image_1.jpg"
import { Link } from "react-router-dom";
import NewsletterSection from "./NewsLetter";
import HeroSection from "./HeroSection";

const Services4 = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Navbar />
      
      {/* Hero Section */}
      {/* <div className="bg-customBlue text-white py-12">
      <div className="max-w-6xl mx-auto px-6">
        <div data-aos="fade-up" className="space-y-4 flex flex-col items-center text-center">
          <h1 className="font-nova-square text-4xl font-thin text-black">
            Agastya: A DNN robot
          </h1>
          <p className="text-black">
          <Link to={"/"}> Home </Link>{' > '} <Link to={"/products"}>Products </Link> {'>'} <Link to={"/products/products4"}>Agastya: A DNN robot </Link>
          </p>
        </div>
      </div>
      </div> */}

      <HeroSection 
        title="Agastya: A DNN robot" 
        breadcrumb={
          <>
            <Link to={"/products"}>Products</Link> {' > '} 
            <Link to={"/products/products4"}>Agastya: A DNN robot</Link>
          </>
        } 
      />

      <div className="max-w-6xl mx-auto p-6">
        {/* Image Section */}
        <div className="flex flex-col md:flex-row items-center gap-8 max-w-6xl mx-auto">
      <div data-aos="zoom-in" className="md:w-1/2">
        <div className="relative group overflow-hidden rounded-xl shadow-2xl">
          <img
            src={image}
            alt="Mission Control Software"
            className="w-full h-[350px] object-cover transform transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        </div>
      </div>
      {/* Introduction */}
      <div data-aos="fade-up" className="prose max-w-none md:w-1/2 space-y-5">
        <p className="text-lg text-gray-700 leading-relaxed text-justify">
        Agastya will revolutionize space security at a scale greater than the self-driving cars. Developed on over decade research on DNN, Agastya is an AI Robot can enable swarms of drones and aircraft to operate autonomously without GPS, communications, or a pilot.
        </p>
        {/* <hr className="border-gray-300 my-4" />
        <p className="text-lg text-gray-700 leading-relaxed">
        Developed on over decade research on DNN, Agastya is an AI Robot can enable swarms of drones and aircraft to operate autonomously without GPS, communications, or a pilot.
        </p> */}
        <hr className="border-gray-300 my-4" />
        <p className="text-lg text-gray-700 leading-relaxed text-justify">
        Agastya AI module uses six cameras and a computer vision system to detect nearby aircraft in a manner like that of a human pilot. Its automatic speech recognition function uses natural language processing techniques to both understand incoming radio messages and communicate with pilots and air traffic controllers using speech. 
        {/* The Computer Vision can divide an image into multiple parts or regions called pixel-level classification. In other words, the scene is parted into different classes such as “building”, “road”, “tree”.         */}
        </p>
      </div>
    </div>
      
      

        {/* Content Sections */}
        <div className="mt-12 space-y-8">
          {/* Introduction */}
          
          {/* CALISTO Overview */}
          <div data-aos="fade-up" className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
            <h2 className="font-nova-square text-2xl font-bold text-gray-800 mb-4">Autonomous Intelligence</h2>
            <p className="text-lg text-gray-700 text-justify">
            While AGASTYA engaged as pilot it analyses, reads and reacts to the mission environment, it can perform task in non-GPS environment. It has 8 integrated AI modules to executes missions autonomously.            </p>
          </div>

          {/* Key Features */}
          <div data-aos="fade-up" className="grid md:grid-cols-3 gap-6">
            {[
              {
                title: "Cutting-Edge Hardware",
                description: "AGASTYA is powered by the world’s most energy-efficient autonomous machine hardware, the NVIDIA® Jetson Orin™ series. Delivering up to 275 trillion operations per second (TOPS), it offers 8X the performance of its predecessor, supporting multiple AI inference pipelines and high-speed interfaces for various sensors.",
                icon: "💻"
              },
              {
                title: "Real-Time Awareness",
                description: "With real-time situational awareness capabilities, AGASTYA enhances decision-making, enabling seamless human-machine interactions. This ensures better outcomes and mission success, even in complex operational environments.",
                icon: "🛰️"
              },
              {
                title: "Holistic ISR Capabilities",
                description: "AGASTYA empowers teams with organic Intelligence, Surveillance, and Reconnaissance (ISR) capabilities. It provides holistic situational awareness across all mission levels, ensuring unparalleled efficiency and adaptability in any scenario.",
                icon: " 🕵️‍♂️ "
              }
            ].map((feature, index) => (
              <div 
                key={index}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 h-72 overflow-y-auto"
              >
                <div className="text-4xl mb-4">{feature.icon}</div>
                <h3 className="font-nova-square text-xl font-semibold text-gray-800 mb-2">{feature.title}</h3>
                <p className="text-lg text-gray-600 text-justify">{feature.description}</p>
              </div>
            ))}
          </div>

          {/* Capabilities List */}
          {/* <div data-aos="fade-up" className="bg-white rounded-xl p-8 shadow-lg">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Key Capabilities</h2>
            <div className="grid md:grid-cols-2 gap-4">
              {[
                "Easy-to-use monitoring and control access",
                "Telecommands generation and management",
                "Non-Destructive Testing",
                "Aerospace Polymers and Plastics Testing",
                "Cloud-based AI mission control",
                "High-performance infrastructure",
                "Advanced encryption and authentication",
                "Mechanical Testing",
                "Aerospace Composites Testing"
              ].map((item, index) => (
                <div 
                  key={index}
                  className="flex items-center space-x-3 p-3 rounded-lg hover:bg-blue-50 transition-colors duration-300"
                >
                  <div className="h-2 w-2 rounded-full bg-blue-500" />
                  <span className="text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div> */}
        </div>
      </div>

      <NewsletterSection />
      <Footer />
    </div>
  );
};

export default Services4;